import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GlobalConfirmDialogComponent } from './shared/components/ui/global-confirm-dialog/global-confirm-dialog.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, GlobalConfirmDialogComponent],
  template: `
    <router-outlet />
    <app-global-confirm-dialog />
  `,
})
export class AppComponent {}
